export default __webpack_public_path__ + "static/media/logo-white.0c4170d8.webp";